export default {
  name: '蔡徐坤',
  position: '求职意向：Web前端工程师',
  infos: [
    { icon: 'dianhua', value: '12345678910' },
    { icon: 'dianziyoujian', value: 'xxxxx@qq.com' },
    { icon: 'xueli', value: '鸡你太美学院（本科）' },
    { icon: 'jisuanjishuiping', value: '计算机科学与技术' },
  ],
  exps: [
    {
      title: '专业技能',
      values: [
        {
          introduce: [
            '熟悉HTML,JS,CSS,熟悉ES5，了解ES6，熟悉Vue开发，了解其核心原理',
            '熟悉常用的数据结构;熟悉计算机网络,操作系统等;',
            '了解Node，有后端开发经验，熟悉MySql,了解Redis，MongoDB',
          ],
        },
      ],
    },
    {
      title: '获奖荣誉',
      values: [
        {
          des: {
            time: '2020年02月',
            tips: ['国家奖学金'],
          },
        },
        {
          des: {
            time: '2020年10月',
            tips: ['国家励志奖学金'],
          },
        },
        {
          des: {
            time: '2020年11月',
            tips: ['XX大赛金牌'],
          },
        },
      ],
    },
    // {
    //     title: '获奖另一种展示方式',
    //     values: [
    //         {
    //             introduce: [
    //                 '2020-12 国家xxx奖',
    //                 '2020-11 省xxx奖',
    //                 '2020-10 校xxx奖',
    //             ]
    //         },
    //     ]
    // },
    {
      title: '校园经历',
      values: [
        {
          des: {
            time: '2018.09 – 2022.06',
            tips: ['五道口职业技术学院', '本科', '软件工程'],
          },
          introduce: [
            '担任(加入)xx实验室/团队 （职称），负责了实验室门户网站的维护，带领团队成员参加了xx大赛，获得xx荣誉',
            '担任xxx，负责了xxx工作，收获了XX技能（如Adobe系列）',
          ],
        },
        {
          des: {
            time: '2018.09 – 2022.06',
            tips: ['五道口职业技术学院', '本科', '软件工程'],
          },
          introduce: [
            '担任(加入)xx实验室/团队 （职称），负责了实验室门户网站的维护，带领团队成员参加了xx大赛，获得xx荣誉',
            '担任xxx，负责了xxx工作，收获了XX技能（如Adobe系列）',
          ],
        },
      ],
    },
    {
      title: '实习经历',
      values: [
        {
          des: {
            time: '2019.12 – 2020.3',
            tips: ['美团', 'Web前端工程师'],
          },
          introduce: [
            '【经历】参与XX项目的研发，解决了xx难题',
            '【贡献】开发了xx插件/工具，解决了xx问题，提升了xx效率',
          ],
        },
      ],
    },
    {
      title: '项目经验',
      values: [
        {
          des: {
            time: '上天入地 - 校园二手交易平台',
            tips: ['github.com/XXX'],
          },
          introduce: [
            '现有的xx方式处理xxx情况存在xx问题',
            '前端部分使用Vue，服务端使用Node/TS/MySQL',
          ],
        },
        {
          des: {
            time: '天地玄黄',
            tips: ['这里可以放生成的短链'],
          },
          introduce: [
            '简介：校园二手交易平台',
            '难点：图片压缩，大量图片加载，级联选择组件',
            '技术栈：Vue/express/typescript/mysql/TS/MySQL',
          ],
        },
      ],
    },
  ],
}
